import { useEffect, useReducer } from "react";

type Action = { type: "performStart"; params: any[] } | { type: "performEnd" };
type State = { params: null | any[]; performing: boolean; performed: boolean };

const initialState = {
  params: null,
  performing: false,
  performed: false
};

const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case "performStart":
      return { ...state, params: action.params, performing: true };
    case "performEnd":
      return { ...state, params: null, performing: false, performed: true };
    default:
      throw new Error();
  }
};

const useAsyncAction = <T extends (..._args: any[]) => Promise<any>>(onAction: T) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(
    () => {
      if (state.performing) {
        let cancelled = false;

        onAction(...(state.params || [])).then(() => {
          if (!cancelled) {
            dispatch({ type: "performEnd" });
          }
        });

        return () => {
          cancelled = true;
        };
      }

      return undefined;
    },
    [dispatch, onAction, state.params, state.performing]
  );

  return {
    onTrigger: (...params: (any | undefined)[]) => dispatch({ type: "performStart", params }),
    performing: state.performing,
    performed: state.performed
  };
};

export default useAsyncAction;
